import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabor = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "labor",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_16857",
			"data-name": "Group 16857",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_12507",
				"data-name": "Path 12507",
				d: "M15,8h4.323a1,1,0,0,1,.928.629l1.606,4.014a2.007,2.007,0,0,1,.143.742v5.948a1,1,0,0,1-1,1H19.169",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				fillRule: "evenodd"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_12508",
				"data-name": "Path 12508",
				d: "M16,20.42H8.17",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				fillRule: "evenodd"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12509",
			"data-name": "Path 12509",
			d: "M22,15H18V11h3.2",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_16858",
			"data-name": "Group 16858",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12510",
					"data-name": "Path 12510",
					d: "M12.556,6H14a1,1,0,0,1,1,1v9H2",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12512",
					"data-name": "Path 12512",
					d: "M18.7,19.3a1.584,1.584,0,1,1-2.24,0,1.584,1.584,0,0,1,2.24,0",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12513",
					"data-name": "Path 12513",
					d: "M7.7,19.3a1.584,1.584,0,1,1-2.24,0,1.584,1.584,0,0,1,2.24,0",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12514",
					"data-name": "Path 12514",
					d: "M5,20.416H3a1,1,0,0,1-1-1V7A1,1,0,0,1,3,6h9.849",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12516",
			"data-name": "Path 12516",
			d: "M0,0H24V24H0Z",
			fill: "none"
		})
	]
});
export default SvgLabor;
